import React, { useMemo } from "react";

const COLORS = ["#F59E0B", "#FF6B6B", "#8B5CF6", "#22C55E", "#38BDF8", "#EC4899", "#FACC15"];

// Lightweight CSS confetti burst. Mount when `show` is true.
export default function Confetti({ show, count = 60 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        left: Math.random() * 100,
        delay: Math.random() * 0.4,
        dur: 1.6 + Math.random() * 1.4,
        color: COLORS[i % COLORS.length],
        size: 8 + Math.random() * 10,
        rot: Math.random() * 360,
      })),
    [count, show] // regenerate each time show toggles true
  );
  if (!show) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-[100] overflow-hidden" data-testid="confetti">
      {pieces.map((p, i) => (
        <span
          key={i}
          style={{
            position: "absolute",
            top: "-5vh",
            left: `${p.left}%`,
            width: p.size,
            height: p.size * 0.5,
            background: p.color,
            borderRadius: 2,
            transform: `rotate(${p.rot}deg)`,
            animation: `confetti-fall ${p.dur}s ${p.delay}s ease-in forwards`,
          }}
        />
      ))}
    </div>
  );
}
